import React, { useState } from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import {
  textOverflow,
  textLeft,
  width100,
  plainList,
  right
} from 'scy/utils.mod.scss';
import { ContainerProductImage, ThumbnailProductImage } from 'scy/ProductImage';
import { Paragraph, H5 } from 'scy/text';
import {
  secondary,
  fontSizeS,
  fontSizeXS,
  sansSerifLight,
  sansSerifRegular
} from 'scy/text/styles.mod.scss';
import { TextButton } from 'scy/buttons';
import Carousel from 'scy/Carousel/base';
import { SmallPrevArrow, SmallNextArrow } from 'scy/Carousel/arrows';
import carouselStyles from 'scy/Carousel/styles.mod.scss';
import { flex, flex1 } from 'scy/flex.mod.scss';
import { tablet_hidden } from 'scy/display.mod.scss';
import border from 'scy/border.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './ProductList.mod.scss';

export default function GiftClaimProductList({ products }) {
  const [featuredProduct, setFeaturedProduct] = useState((products || [])[0]);

  if (!featuredProduct) return null;

  const otherProducts = products.filter(
    ({ sku_id }) => sku_id !== featuredProduct.sku_id
  );

  const title =
    featuredProduct.title +
    (featuredProduct.subtitle ? ` - ${featuredProduct.subtitle}` : '');

  const description = _.truncate(featuredProduct.description, {
    length: 160,
    separator: /( |, |; |\. |\? |! |" |' |\) )/
  });

  return (
    <>
      <ContainerProductImage
        className={styles.productImage}
        product={featuredProduct}
      >
        {featuredProduct.quantity > 1 && (
          <div className={styles.badge}>{featuredProduct.quantity}</div>
        )}
      </ContainerProductImage>

      <div className={padding.tablet_sm}>
        <h3 className={styles.title}>{title}</h3>
        <Paragraph>{description}</Paragraph>
        <OtherProducts
          featuredProduct={featuredProduct}
          otherProducts={otherProducts}
          setFeaturedProduct={setFeaturedProduct}
        />
      </div>
    </>
  );
}

function OtherProducts({ featuredProduct, otherProducts, setFeaturedProduct }) {
  if (!otherProducts.length) return null;

  return (
    <>
      <h4 className={styles.subtitle}>Plus {otherProducts.length} more...</h4>

      <ul className={`${plainList} ${tablet_hidden}`}>
        {otherProducts.map(product => (
          <ListLitem
            key={product.sku_id}
            product={product}
            onClick={() => setFeaturedProduct(product)}
          />
        ))}
      </ul>

      <div className={styles.featuredThumbnailContainer}>
        <ThumbnailProductImage
          product={featuredProduct}
          className={styles.featuredThumbnail}
        />
      </div>
      <div className={styles.thumbnailCarouselContainer}>
        <ThumbnailCarousel
          products={otherProducts}
          setFeaturedProduct={setFeaturedProduct}
        />
      </div>
    </>
  );
}

function ListLitem({ product, onClick }) {
  const { quantity, title, subtitle, volume } = product;
  return (
    <li>
      <TextButton
        noUnderline
        className={classnames(textLeft, width100)}
        displayClass={flex}
        onClick={onClick}
      >
        <ThumbnailProductImage product={product} className={styles.thumbnail} />
        <div
          className={classnames(
            padding.xs,
            padding.top_0,
            margin.xs,
            margin.top_0,
            border.bottomMedium,
            flex1,
            textOverflow
          )}
        >
          <div
            className={classnames(
              right,
              padding.xxs,
              padding.tablet_all0,
              secondary,
              fontSizeXS,
              sansSerifRegular
            )}
          >
            Qty {quantity}
          </div>
          <H5 uppercase tag="div" className={tablet_hidden}>
            {title}
          </H5>
          <div
            className={classnames(
              textOverflow,
              secondary,
              fontSizeS,
              sansSerifLight,
              tablet_hidden
            )}
          >
            {subtitle}
          </div>
          <div
            className={classnames(
              textOverflow,
              secondary,
              fontSizeS,
              sansSerifLight,
              tablet_hidden
            )}
          >
            {volume}
          </div>
        </div>
      </TextButton>
    </li>
  );
}

function ThumbnailCarousel({ products, setFeaturedProduct }) {
  return (
    <Carousel
      slidesToShow={3}
      slidesToScroll={3}
      prevArrow={<SmallPrevArrow />}
      nextArrow={<SmallNextArrow />}
    >
      {products.map(product => (
        <div
          key={product.sku_id}
          className={carouselStyles.productImageContainer}
        >
          <>
            <ThumbnailProductImage
              product={product}
              className={`${carouselStyles.productImage} ${
                styles.carouselThumbnail
              }`}
              onClick={() => setFeaturedProduct(product)}
            />
            <div className={`${secondary} ${fontSizeXS} ${sansSerifRegular}`}>
              Qty {product.quantity}
            </div>
          </>
        </div>
      ))}
    </Carousel>
  );
}
